import { render, staticRenderFns } from "./RestorePasswordPage.vue?vue&type=template&id=02e07a23&scoped=true"
import script from "./RestorePasswordPage.vue?vue&type=script&lang=ts"
export * from "./RestorePasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./RestorePasswordPage.vue?vue&type=style&index=0&id=02e07a23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e07a23",
  null
  
)

export default component.exports